import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-dommages-ouvrage',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-dommages-ouvrage.component.html',
  styleUrls: ['./assurance-dommages-ouvrage.component.scss']
})
export class AssuranceDommagesOuvrageComponent {
  title = 'Assurance Dommages Ouvrage';
  subtitle = '';
  phoneNumber = '01 42 27 12 43';
  heroImage = 'assets/static_pages_images/dommage.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Dommages-Ouvrage', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance Œuvres d\'Art',
    link: '/assurance-oeuvres-art-bijoux'
  };

  nextPage = { 
    title: 'Assurance Animaux',
    link: '/assurance-animaux'
  };

  constructor(private router: Router) {}
}
